import { useParams } from "react-router-dom";
import DiffViewer from "admin/components/dataset-detail/DiffViewer";
import SyncControls from "admin/components/dataset-detail/SyncControls";
import useDatasetDiff from "admin/components/dataset-detail/hooks/useDatasetDiff";
import { DATASET_DETAIL_PAGE_TITLE } from "admin/types/constants/page-titles";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { AdminPage } from "~/pages/manifold-nextgen/components/admin/AdminPage";
import { nextgenAdminDatasetsPath } from "~/pages/manifold-nextgen/paths";
import { ROUTE_ADMIN, ROUTE_DATASETS } from "~/router/constants";

const DatasetDetail = ({ isNextGen = false }: { isNextGen?: boolean }) => {
  useDocumentTitle(DATASET_DETAIL_PAGE_TITLE);
  useAppHeader({ title: DATASET_DETAIL_PAGE_TITLE });

  const { datasetId } = useParams();
  const { data: diffData, isLoading, error, mutate } = useDatasetDiff();

  return (
    <AdminPage
      title="Dataset Admin"
      description={<span className="font-mono">{datasetId}</span>}
      back={{
        href: isNextGen ? nextgenAdminDatasetsPath() : `${ROUTE_ADMIN}/${ROUTE_DATASETS}`,
        label: "Back to datasets",
      }}
      width={isNextGen ? "default" : "full"}
    >
      <div className="flex flex-col gap-2">
        <h2 className="text-base font-semibold">Diff</h2>
        <p className="text-sm text-muted-foreground">
          Differences between Catalog and Access Controller state for this dataset.
        </p>
        <DiffViewer diffData={diffData} isLoading={isLoading} error={error} />
      </div>

      <SyncControls onSyncComplete={() => mutate()} />
    </AdminPage>
  );
};

export default DatasetDetail;
